import { useTranslation } from "react-i18next";
import { Check } from "@phosphor-icons/react";

const steps = [
  { key: "account", labelKey: "auth.progress.account" },
  { key: "verify", labelKey: "auth.progress.verify" },
  { key: "plan", labelKey: "auth.progress.plan" },
];

const AuthProgressBar = ({ currentStep }) => {
  const { t } = useTranslation();
  const currentIndex = steps.findIndex((s) => s.key === currentStep);

  return (
    <div className="flex items-center justify-center mb-8">
      {steps.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;

        return (
          <div key={step.key} className="flex items-center">
            {/* Step circle + label */}
            <div className="flex flex-col items-center">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300
                  ${isCompleted ? "bg-green-500 text-white" : ""}
                  ${isCurrent ? "bg-primary text-white ring-2 ring-primary/30 ring-offset-2 ring-offset-bg" : ""}
                  ${!isCompleted && !isCurrent ? "bg-grey border border-gray-600 text-gray-500" : ""}
                `}
              >
                {isCompleted ? <Check size={18} weight="bold" /> : index + 1}
              </div>
              <span
                className={`text-xs mt-2 font-medium transition-colors duration-300
                  ${isCurrent ? "text-white" : ""}
                  ${isCompleted ? "text-green-400" : ""}
                  ${!isCompleted && !isCurrent ? "text-gray-500" : ""}
                `}
              >
                {t(step.labelKey)}
              </span>
            </div>

            {/* Connector line */}
            {index < steps.length - 1 && (
              <div
                className={`w-16 sm:w-24 h-0.5 mx-2 sm:mx-4 mb-5 transition-colors duration-300
                  ${index < currentIndex ? "bg-green-500" : "bg-gray-600"}
                `}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AuthProgressBar;
